import { Circle as CircleStyle, Fill, Stroke, Style, Text, Icon } from "ol/style";
import { MultiPoint } from "ol/geom";
import { DrawType } from "./enums";

const white = [255, 255, 255, 1];
const blue = [0, 153, 255, 1];
const blueFill = [0, 153, 255, 0.3];
const orange = [250, 140, 35, 1];
const orangeFill = [250, 140, 35, 0.15];
const primaryDark = "#4c4c4c";

const vertice = new CircleStyle({
    radius: 6,
    fill: new Fill({
        color: blue
    }),
    stroke: new Stroke({
        color: white,
        width: 1.5
    })
});

const strokeStyle = new Stroke({
    color: orange,
    width: 3
});

const selectStrokeStyle = new Stroke({
    color: blue,
    width: 3
});

const getLabel = (label: string): Text =>
    new Text({
        font: 'normal normal bold 20px "Mulish"',
        text: label.toString(),
        textBaseline: "bottom",
        offsetY: -10,
        stroke: new Stroke({
            color: white,
            width: 1.8
        })
    });

export const getDrawingSymbol = (type: DrawType, label: string, isSelect?: boolean, isModify?: boolean): Style => {
    if (type === DrawType.Polyline) {
        if (isModify) {
            return new Style({
                image: vertice
            });
        }
        if (isSelect) {
            return [
                new Style({
                    stroke: selectStrokeStyle
                }),
                new Style({
                    image: vertice,
                    geometry: (feature) => new MultiPoint(feature.getGeometry().getCoordinates())
                }),
                new Style({
                    text: getLabel(label)
                })
            ];
        }
        return new Style({
            stroke: strokeStyle,
            text: getLabel(label)
        });
    } else {
        return [
            new Style({
                image: new CircleStyle({
                    fill: new Fill({
                        color: white
                    }),
                    stroke: new Stroke({
                        color: isModify ? blue : isSelect ? blue : orange,
                        width: isModify ? 2 : 3
                    }),
                    radius: 12
                }),
                text: new Text({
                    font: 'normal normal 400 20px "icomoon"',
                    fill: new Fill({
                        color: isModify ? blue : primaryDark
                    }),
                    text: String.fromCodePoint(0xe900) // the value of the CSS 'content' property (\ replaced with 0x)
                })
            }),
            new Style({ text: getLabel(label) })
        ];
    }
};

export const getPolygonSymbol = (strokeWidth?: number): Style => {
    return new Style({
        stroke: new Stroke({
            color: [221, 92, 70, 0.8],
            width: strokeWidth || 1.5
        }),
        fill: new Fill({
            color: [221, 92, 70, 0.1]
        })
    });
};

export const getOverviewMapSymbol = (type: DrawType): Style => {
    return type === DrawType.Polyline
        ? new Style({
              stroke: strokeStyle
          })
        : new Style({
              image: new CircleStyle({
                  fill: new Fill({
                      color: orange
                  }),
                  radius: 6
              })
          });
};
